/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLanguageDto } from '../../models/create-language-dto';
import { Language } from '../../models/language';

export interface LanguagesControllerCreate$Params {
  
    /**
     * The language data to create a new language
     */
    body: CreateLanguageDto
}

export function languagesControllerCreate(http: HttpClient, rootUrl: string, params: LanguagesControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Language>> {
  const rb = new RequestBuilder(rootUrl, languagesControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Language>;
    })
  );
}

languagesControllerCreate.PATH = '/languages';
